import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import MonitorItem from '@components/monitorItem'
import {pageTimelineList, getMonitorList, playTimeline} from '@apis'
import lightBtnVideoBg from '@assets/img/lightBtnVideoBg.png'
import mapBg1 from '@assets/img/mapBg1.png'
import defaultPicture from '@assets/img/defaultPicture.png'
import timelineJump from '@assets/img/timelineJump.png'
import './index.less'

let timelineSwiper = null
let timelineInterval
let timelineTimeout

function repairNum(num) {
  if (num < 10) {
    return `0${num}`
  }
  return num
}

const CockpitTimeline = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo
    const [timelineList, setTimelineList] = useState([])
    const [monitorList, setMonitorList] = useState([])
    const [centerTimeline, setCenterTimeline] = useState()
    const [leftTimeline, setLeftTimeline] = useState()
    const [rightTimeline, setRightTimeline] = useState()
    const [chapter, setChapter] = useState('')
    const [nextChapter, setNextChapter] = useState('')
    const [playType, setPlayType] = useState(null)

    // 查询节目列表
    async function getTimelineList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId,
      }
      const res = await pageTimelineList(params)
      if (res && res.data) {
        const result = res.data.filter(one => one.dataBigscreenDisplay === 1).map(item => {
          const result = {
            ...item,
            content: JSON.parse(item.content)
          }
          return result
        })
        setTimelineList(result)
        videoLoad(result)
        result.map((item, index) => {
          if(item.playStatus == 1) {
            setCenterTimeline(JSON.parse(item.bindSpecialSource)[0])
            setLeftTimeline(JSON.parse(item.bindSpecialSource)[1] ? JSON.parse(item.bindSpecialSource)[1] : null)
            setRightTimeline(JSON.parse(item.bindSpecialSource)[2] ? JSON.parse(item.bindSpecialSource)[2] : null)
            setPlayType(index)
            videoMuted()
          }
        })
      }
    }

    async function queryMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        setMonitorList(res.data)
      }
    }

    // 视频静音
    function videoMuted() {
      timelineInterval = setInterval(() => {
        for(let i=0; i<document.getElementsByTagName('video').length; i++) {
          document.getElementsByTagName('video')[i].muted = true
        }
      }, 50)
      timelineTimeout = setTimeout(() => {
        clearInterval(timelineInterval)
      }, 3000)
    }

    // 单击某个节目开始播放
    async function playpro(index, record, status) {
      clearInterval(timelineInterval)
      clearTimeout(timelineTimeout)
      const params = {
        id: record.id,
        status
      }
      const res = await playTimeline(params)
      if(status) {
        for(let i=0; i<document.getElementsByTagName('video').length; i++) {
          document.getElementsByTagName('video')[i].play()
        }
      }
      setPlayType(index)
      setCenterTimeline(JSON.parse(record.bindSpecialSource)[0])
      setLeftTimeline(JSON.parse(record.bindSpecialSource)[1])
      setRightTimeline(JSON.parse(record.bindSpecialSource)[2])
      videoMuted()
    }

    // 视频预加载
    function videoLoad(res) {
      let video = new Array()
      res.map((item, i) => {
        if(item.bindSpecialSource.split('http')[0] == "") {
          video[i] = document.createElement('video')
          video[i].setAttribute('src', item.bindSpecialSource)
          video[i].load()
        }
      })
    }

    // 获取正在播放节目的当前篇章
    function getTimelineChapter() {
      window.webSocket = null;
      //判断当前浏览器是否支持WebSocket
      if ('WebSocket' in window) {
        // webSocket = new WebSocket("ws://"+location.host+"/ws/UI");
        webSocket = new WebSocket("ws://47.98.235.96:20015/ws" + brokerId);
      } else {
        alert('Not support websocket')
      }
      webSocket.onerror = function() {
      };
      webSocket.onopen = function(event) {
      }
      webSocket.onmessage =  function(event) {
        if(event.data == 'end') {
          setTimeout(() => {
            getTimelineList()
            setCenterTimeline()
            setLeftTimeline()
            setRightTimeline()
            setPlayType(null)
          }, 3000)
          return setChapter('已结束')
        }
        setChapter(event.data)
      }
      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = function() {
        webSocket.close();
      }
    }

    useEffect(() => {
      getTimelineChapter()
      getTimelineList()
      queryMonitorList()
      setTimeout(() => {
        timelineSwiper = new Swiper(".mySwiper", {
          loop: true,
          slidesPerView: 3,
          centeredSlides: true,
          initialSlide :1,
          spaceBetween: 40,
          // loopAdditionalSlides: 0,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
        })
        const swiper2 = new Swiper(".mySwiper2", {
          slidesPerView: 4,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
        })
      }, 500)
    }, [])

    useEffect(() => {
      if(chapter && timelineList.length) {
        let list = timelineList[playType].content.filter(value => value.type == "alias")
        list.map((item, index) => {
          if(item.name == chapter) {
            setNextChapter(list.length>index+1 ? list[index+1].name : '')
          }
        })
      }
    }, [chapter])

    return (
      <React.Fragment>
        <div className="timeline">
          <img className='timeline-img' src={mapBg1}/>
          <div className="swiper mySwiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div 
                  className='mask' 
                ></div>
                {
                  leftTimeline ? (
                    <video
                      autoPlay
                      muted
                      loop
                      controls
                      src={leftTimeline ? leftTimeline : ''}
                      className="timeline-video"
                    />) : (<img src={defaultPicture}/>)
                }
              </div>
              <div className="swiper-slide">
                <div 
                  className='mask' 
                ></div>
                {
                  centerTimeline ? (
                    <video
                      autoPlay
                      muted
                      loop
                      controls
                      src={centerTimeline}
                      className="timeline-video"
                    />) : (<img src={defaultPicture}/>)
                }
              </div>
              <div className="swiper-slide">
                <div 
                  className='mask' 
                ></div>
                {
                  rightTimeline ? (
                    <MonitorItem
                      url={rightTimeline ? rightTimeline : ''}
                      accessToken={monitorList[0] ? monitorList[0].monitorAccessToken : ''}
                    />
                  ) : (<img src={defaultPicture}/>)
                }
              </div>
            </div>
          </div>
          <div className='timeline-bottom'>
            <div className="swiper2 mySwiper2">
              <div className="swiper-wrapper">
                {
                  timelineList.map((item, index) => (
                    <div 
                      className="swiper-slide" 
                      onClick={() => {
                        playpro(index, item, 1)
                        setTimeout(() => {
                          timelineSwiper = null
                          timelineSwiper = new Swiper(".mySwiper", {
                            loop: true,
                            slidesPerView: 3,
                            centeredSlides: true,
                            initialSlide :1,
                            spaceBetween: 40,
                            loopAdditionalSlides: 0,
                            observer:true,//修改swiper自己或子元素时，自动初始化swiper
                            observeParents:true,//修改swiper的父元素时，自动初始化swiper
                          })
                        }, 300)
                      }}
                    >
                      <img
                        className='timeline-menu-bg'
                        src={lightBtnVideoBg}
                      />
                      {
                        index === playType ? (
                          <React.Fragment>
                            {
                              chapter == '已结束' ? <div className="pg-active-con">{chapter}</div> : 
                                <div className="pg-active-con">
                                  <div>当前播放篇章:</div><br/>
                                  <span>{chapter}</span><br/>
                                  <div>下一播放篇章:</div><br/>
                                  <span>{nextChapter ? nextChapter : '暂无'}</span>
                                </div>
                            }
                          </React.Fragment>
                        ) : (
                          <img
                            className='timeline-menu-img'
                            src={item.coverBannerUrl}
                          />
                        )
                      }
                      <div className='timeline-name'>{repairNum(index+1)}/ {item.name}</div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        <img className='timelineJump' src={timelineJump} onClick={() => {window.location.href= "http://" + window.location.hostname + ":20005/manage/lightSmc/lightShowProgramManagement"}}/>
      </React.Fragment>
    )
  })
)

export default CockpitTimeline